// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__0zYO9","tr":"Table_tr__W_Xk4","td":"Table_td__whptT"};